<template>
    <div class="consult-container">
        <ComDetail :detail="detail" :detailCols="detailCols" :onCancel="onCancel"></ComDetail>

        <div class="search-container">
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="举报类型">
                    <el-select v-model="formInline.reportType" placeholder="请选择举报类型" clearable>
                        <el-option v-for="item in reportType" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="被举报人">
                    <el-input v-model="formInline.reportName" placeholder="请输入被举报人"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table-container">
            <el-table :data="tableData" :pagination="pagination" border style="width: 100%">
                <el-table-column prop="memberName" label="举报人" align="center">
                </el-table-column>
                <el-table-column prop="reportDate" label="举报时间" align="center" :formatter="dateFormat">
                </el-table-column>
                <el-table-column prop="reportType" align="center" label="举报类型">
                    <template slot-scope="scope">
                        {{ getPostTypeName(scope.row.reportType) }}
                    </template>
                </el-table-column>
                <el-table-column prop="reportName" align="center" label="被举报人">
                </el-table-column>
                <el-table-column prop="reportContent" align="center" label="举报原因">
                </el-table-column>
                <el-table-column prop="reviewStatus" align="center" label="审核结果">
                    <template slot-scope="scope">
                        <span v-if="scope.row.reviewStatus === 1">审核通过</span>
                        <span v-else-if="scope.row.reviewStatus === 2">审核未通过</span>
                        <span v-else-if="scope.row.reviewStatus === 3">待审核</span>
                        <span v-else>未知状态</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="100">
                    <template slot-scope="scope">
                        <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 40]"
                    :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.total">
                </el-pagination>
            </div>
        </div>
        <!-- 回复功能 -->
        <el-drawer title="回复" :visible.sync="drawer" direction="rtl" :before-close="handleClose">
            <el-form ref="form" :model="drawerForm" label-width="80px">
                <el-form-item label="回复内容">
                    <el-input type="textarea" rows="6" v-model="drawerForm.recordContent"></el-input>
                </el-form-item>
            </el-form>
            <div class="drawer-footer">
                <el-button @click="cancelForm">取 消</el-button>
                <el-button type="primary" @click="submitReply" :loading="loading">{{ loading ? '提交中 ...' : '确 定'
                    }}</el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import moment from "moment";
import ComDetail from '@/components/common/comDetail.vue';
import { repotlist } from '@/api/community'
import { reportType } from '@/data/constant'
export default {
    name: 'AdminStaticsPostRecord',
    components: {
        ComDetail
    },
    data() {
        return {
            reportType,
            detail: {
                visible: false,
                record: {},
                columns: 1
            },
            detailCols: [
                {
                    label: '举报人',
                    prop: 'memberName'
                },
                {
                    label: '举报时间',
                    prop: 'reportDate',
                    formatter: (row) => moment(row.reportDate).format('YYYY-MM-DD HH:mm:ss'),
                },
                {
                    label: '被举报人',
                    prop: 'reportName',
                },
                {
                    label: '举报原因',
                    prop: 'reportContent'
                },
                {
                    label: '内容',
                    prop: 'content',
                },
            ],
            drawer: false,
            formInline: {
                reportName: '',
                reportType: undefined,
            },
            pagination: {
                currentPage: 1, // 当前页
                pageSize: 10, // 每页显示条数
                total: 0, // 总条数
                layout: 'total, prev, pager, next, jumper', // 分页布局
            },
            tableData: [],
            drawerForm: {
                recordContent: ''
            },
            record: {}
        };
    },

    mounted() {
        this.loadData()
    },
    methods: {
        // 查看
        onCancel() {
            this.detail.visible = false
        },
        cancelForm() {
            this.drawer = false
        },
        // 时间转换
        dateFormat(row) {
            return moment(row.reportDate).format('YYYY-MM-DD HH:mm:ss');
        },
        getPostTypeName(type) {
            return this.reportType.find(item => item.value === type)?.label || ''
        },
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.loadData()
        },
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadData()
        },
        handleClick(row) {
            this.detail.visible = true
            this.detail.record = row
        },
        onSubmit() {
            this.pagination.currentPage = 1
            this.loadData()
        },
        async loadData() {
            const params = {}
            if (this.formInline.reportType) {
                params.reportType = this.formInline.reportType
            }
            if (this.formInline.reportName) {
                params.reportName = this.formInline.reportName
            }
            await repotlist({
                pageNo: this.pagination.currentPage - 1,
                pageSize: this.pagination.pageSize,
                ...params,
            }).then(res => {
                this.tableData = res.data.content
                this.pagination.total = res.data.totalElements
            })
        }
    },
};
</script>
<style lang="scss" scoped>
.consult-container {
    background: #fff;
    padding: 24px 0;

    .search-container {
        padding: 0 16px;
        border-bottom: 1px solid #EBEEF5;
    }

    .table-container {
        padding: 16px;
    }

    .pagination-container {
        margin-top: 16px;
        text-align: right;
    }

    .drawer-footer {
        text-align: center;
    }
}

::v-deep .el-drawer__body {
    padding: 0 16px;
}
</style>